import request from '@/request'

export async function getMyPurchases () {
  const response = await request({
    url: `/users/me/purchases`,
    method: 'get'
  })

  return response.data.data
}

export async function getMyPurchaseStatusByCourse (courseId) {
  const response = await request({
    url: `/users/me/courses/${courseId}/purchases?status`,
    method: 'get'
  })

  return response.data
}
